// import React, { useState } from "react";
// import { Input, FormFeedback, Tooltip } from "reactstrap";

// const TextareaInput = ({
//     label = "Enter Text", // Default label
//     placeholder = "Enter your text here", // Default placeholder
//     required = false, 
//     maxLength = 500, // Default max length
//     layout = "below", // Layout: "inline" or "below"
//     value = "", // Initial value
//     resizable = true, // Default resizable
//     name = "textarea", 
//     id = "textareaInput", 
//     onChange = () => {}, 
//     onBlur = () => {}, 
//     requiredErrorMessage = "This field is required.",
//     maxLengthErrorMessage = `You can enter up to ${maxLength} characters only.`,
//     showHelp = false, 
//     helpText = "Enter Description", // Help text for tooltip
// }) => {
//     const [inputValue, setInputValue] = useState(value);
//     const [errors, setErrors] = useState({});
//     const [tooltipOpen, setTooltipOpen] = useState(false);
    
//     // Validation for required and max length
//     const validateTextarea = (value) => {
//         const newErrors = {};
//         if (required && !value) {
//             newErrors.required = requiredErrorMessage;
//         } else if (value.length > maxLength) {
//             newErrors.maxLength = maxLengthErrorMessage;
//         }
//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     // Handle input change and validation
//     const handleInputChange = (e) => {
//         const newValue = e.target.value;
//         setInputValue(newValue);
//         validateTextarea(newValue);
//         onChange(e);
//     };

//     // Handle blur event with validation
//     const handleInputBlur = (e) => {
//         validateTextarea(e.target.value);
//         onBlur(e);
//     };

//     return (
//         <div className={layout === "inline" ? "d-flex align-items-center" : ""}>
//             <label htmlFor={id} className="d-flex" style={{ width: layout === "inline" ? "20%" : "100%" }}>
//                 {label}
//                 {required && <span className="text-danger ml-1">*</span>}
//                 {showHelp && (
//                     <span id="helpTooltip" className="px-2">
//                         <i className="ri-question-line" style={{ cursor: "pointer", fontSize: "16px" }}></i>
//                     </span>
//                 )}
//             </label>
//             {showHelp && (
//                 <Tooltip
//                     placement="right"
//                     isOpen={tooltipOpen}
//                     target="helpTooltip"
//                     toggle={() => setTooltipOpen(!tooltipOpen)}
//                 >
//                     {helpText}
//                 </Tooltip>
//             )}
//             <div className="w-100">
//                 <Input
//                     type="textarea"
//                     name={name}
//                     id={id}
//                     placeholder={placeholder}
//                     value={inputValue}
//                     onChange={handleInputChange}
//                     onBlur={handleInputBlur}
//                     invalid={!!errors.required || !!errors.maxLength}
//                     style={{
//                         resize: resizable ? "both" : "none", // Disable resizing if resizable is false
//                     }}
//                     maxLength={maxLength}
//                 />
//                 {errors.required && <FormFeedback>{errors.required}</FormFeedback>}
//                 {errors.maxLength && <FormFeedback>{errors.maxLength}</FormFeedback>}
//                 <div className="text-muted mt-1">
//                     {inputValue.length}/{maxLength} characters
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default TextareaInput;










import React, { useState, useEffect } from "react";
import { Input, FormFeedback, Tooltip } from "reactstrap";

const TextareaInput = ({
    label = "Enter Text",
    placeholder = "Enter your text here",
    required = false,
    maxLength = 500,
    layout = "below",
    value = "",
    resizable = true,
    name = "textarea",
    id = "textareaInput",
    onChange = () => {},
    onBlur = () => {},
    requiredErrorMessage = "This field is required.",
    maxLengthErrorMessage = `You can enter up to ${maxLength} characters only.`,
    showHelp = false,
    helpText = "Enter Description",
    disabled = false, // Add disabled prop
    validateTrigger = false, // Add validateTrigger prop
}) => {
    const [inputValue, setInputValue] = useState(value);
    const [errors, setErrors] = useState({});
    const [tooltipOpen, setTooltipOpen] = useState(false);

    // Validate textarea based on required and maxLength
    const validateTextarea = (value) => {
        const newErrors = {};
        if (required && !value) {
            newErrors.required = requiredErrorMessage;
        } else if (value.length > maxLength) {
            newErrors.maxLength = maxLengthErrorMessage;
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    useEffect(()=>{setInputValue(value)},[value])

    // Validate when validateTrigger is true
    useEffect(() => {
        if (validateTrigger) {
            validateTextarea(inputValue);
        }
    }, [validateTrigger, inputValue]);

    // Handle input change and validation
    const handleInputChange = (e) => {
        const newValue = e.target.value;
        setInputValue(newValue);
        validateTextarea(newValue);
        onChange(e);
    };

    // Handle blur event with validation
    const handleInputBlur = (e) => {
        validateTextarea(e.target.value);
        onBlur(e);
    };

    return (
        <div className={layout === "inline" ? "d-flex align-items-center" : ""}>
            <label htmlFor={id} className="d-flex" style={{ width: layout === "inline" ? "20%" : "100%" }}>
                <span>{label}
                {required && <span className="text-danger ml-1">*</span>}
                </span>
                {showHelp && (
                    <span id="helpTooltip" className="px-2">
                        <i className="ri-question-line" style={{ cursor: "pointer", fontSize: "16px" }}></i>
                    </span>
                )}
            </label>
            {showHelp && (
                <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target="helpTooltip"
                    toggle={() => setTooltipOpen(!tooltipOpen)}
                >
                    {helpText}
                </Tooltip>
            )}
            <div className="w-100">
                <Input
                    type="textarea"
                    name={name}
                    id={id}
                    placeholder={placeholder}
                    value={inputValue}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                    invalid={!!errors.required || !!errors.maxLength}
                    disabled={disabled} // Disable based on the disabled prop
                    style={{
                        resize: resizable ? "both" : "none",
                    }}
                    maxLength={maxLength}
                />
                {errors.required && <FormFeedback>{errors.required}</FormFeedback>}
                {errors.maxLength && <FormFeedback>{errors.maxLength}</FormFeedback>}
                <div className="text-muted mt-1">
                    {inputValue.length}/{maxLength} characters
                </div>
            </div>
        </div>
    );
};

export default TextareaInput;
